import React, { useEffect, useState } from "react";
import useSelectedFinYear from "../../../utils/selectedFinyear";
import CustomDate1 from "../../../Pages/corpaction/corpActionMaster/date/CustomDate1";
import CustomDate from "../../../Pages/corpaction/corpActionMaster/date/CustomDate";
import { format, subDays } from "date-fns";
import { actionPerm, actionPermissions } from "../../authNavigation/AuthNavbar";
import { contractAddIcon } from "../../../assetData/icons";

const MFNavHeader = ({ setFilter, setIsImportPopupOpen }) => {
  const [handleSetValue, setHandleSetValue] = useState();
  const {
    startFinDate,
    startFinYear,
    endFinDate,
    currentFinYear,
    currentDateStr,
  } = useSelectedFinYear();

  const handleFilter = (val) => {
    if (val === "empty") {
      setHandleSetValue();
      setFilter();
    } else {
      setFilter(handleSetValue);
    }
  };

  useEffect(() => {
    if (!currentDateStr) return;
    const cur = new Date(currentDateStr);
    const exDate = subDays(cur, 1);
    const recordDt = subDays(exDate, 7);

    setHandleSetValue({
      nse_exdate: format(exDate, "yyyy-MM-dd"),
      bookclose_recorddate: format(recordDt, "yyyy-MM-dd"),
    });
    setFilter({
      nse_exdate: format(exDate, "yyyy-MM-dd"),
      bookclose_recorddate: format(recordDt, "yyyy-MM-dd"),
    });
  }, [currentDateStr]);

  return (
    <div className=" flex w-full items-baseline gap-2 pt-[10px]">
      <div className="mb-8 flex w-full flex-wrap items-baseline gap-4">
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Start Date</label>
            <CustomDate
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.bookclose_recorddate}
              setHandleSetValue={setHandleSetValue}
              min={startFinDate}
              max={
                handleSetValue?.nse_exdate
                  ? handleSetValue?.nse_exdate
                  : startFinYear === currentFinYear
                  ? currentDateStr
                  : endFinDate
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>End Date</label>
            <CustomDate1
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.nse_exdate}
              setHandleSetValue={setHandleSetValue}
              handleValue={handleSetValue}
              min={
                handleSetValue?.bookclose_recorddate
                  ? handleSetValue?.bookclose_recorddate
                  : startFinDate
              }
              max={
                startFinYear === currentFinYear ? currentDateStr : endFinDate
              }
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end space-x-4">
        <div className=" flex  items-stretch gap-4 text-neutral-600">
          <div className="flex   flex-col gap-3 ">
            <label className="text-[#fff0]">.</label>
            <button
              onClick={() => handleFilter()}
              className="w-full max-w-[100px] gap-2 rounded-md bg-[#F2673A] px-6 py-[8px] text-center font-semibold text-white hover:brightness-95"
            >
              SUBMIT
            </button>
          </div>
        </div>

        <div className=" flex items-stretch gap-4 text-neutral-600">
          <div className="flex  flex-col gap-3 ">
            <label className="text-[#fff0]">.</label>
            <button
              onClick={() => handleFilter("empty")}
              className="w-full max-w-[100px]  gap-2 rounded-md bg-[#F2673A] px-6 py-[8px] text-center font-semibold text-white hover:brightness-95"
            >
              CLEAR
            </button>
          </div>
        </div>
        <div className=" flex items-stretch gap-4 text-neutral-600">
          <div className="flex  flex-col gap-3 ">
            <label className="opacity-0">.</label>
            <button
              onClick={() => setIsImportPopupOpen(true)}
              disabled={
                !actionPerm(actionPermissions("import", "Mutual Fund"))
                  ?.add_perm
              }
              className={`flex w-[200px] whitespace-nowrap disabled:cursor-not-allowed items-center justify-center gap-2 rounded border-[1px] border-[#636363]  py-[8px] text-center font-bold text-[#636363] disabled:opacity-50 max-sm:w-full`}
            >
              <img src={contractAddIcon} alt="i4Invest" />
              Import MF Scheme
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MFNavHeader;
